const state = {
  instantOrderList: []
}
const mutations = {
  SET_INSTANT_LIST: (state, data) => {
    state.instantOrderList = data
  }
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
